export enum ElmHardwareCategory {
  NotebookPreparation = 1,
  MobilePhone = 2,
  MobilePhoneContract = 3,
}
